import axios from '@/lib/axios';
import { useQueries, useQuery } from '@tanstack/react-query';
import { Pager, PurchaseOrder, SalesOrder, TeamPurchaseOrderPhase, UserInvitation, Workspace, WorkspacePayment } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2330. ワークスペース支払履歴一覧
 * [GET] /workspaces/:identifier/workspace_payments
 */
type Props = {
  identifier: string;
  page: number;
  per: number;
};

export type WorkspacePaymentResponse = {
  workspace_payments: WorkspacePayment[];
  pager: Pager;
};

const workspacePayments = (props: Props): Promise<WorkspacePaymentResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/workspace_payments`, { params: props });
};

export const useWorkspacePayments = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, props.page, props.per],
    queryFn: () => workspacePayments(props),
  });
};
